import { render, staticRenderFns } from "./ExtraConfigNodo.vue?vue&type=template&id=3fd87d96&scoped=true"
import script from "./ExtraConfigNodo.vue?vue&type=script&lang=js"
export * from "./ExtraConfigNodo.vue?vue&type=script&lang=js"
import style0 from "./ExtraConfigNodo.vue?vue&type=style&index=0&id=3fd87d96&prod&lang=scss&scoped=true"
import style1 from "./ExtraConfigNodo.vue?vue&type=style&index=1&id=3fd87d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd87d96",
  null
  
)

export default component.exports